import { z } from "zod";

export const AudienceValidation = z.object({
  name: z.string().min(1, "Nama wajib diisi"),
  email: z.string().email("Email tidak valid"),
  phone: z.string().min(10, "Nomor HP minimal 10 digit"),
  originInstansi: z.string().min(1, "Instansi asal wajib diisi"),
  provinceCode: z.string().min(1, "Kode provinsi wajib diisi"),
  cityCode: z.string().min(1, "Kode kota wajib diisi"),
  address: z.string().min(1, "Alamat wajib diisi"),
  purpose: z.string().min(1, "Tujuan wajib diisi"),
  audienceDate: z.coerce
    .date({
      required_error: "Tanggal kunjungan wajib diisi",
      invalid_type_error: "Tanggal kunjungan tidak valid",
    })
    .transform((v) => v.toISOString().split("T")[0]),
  audienceTime: z
    .string()
    .regex(/^([0-1]\d|2[0-3]):([0-5]\d)$/, "Format jam harus HH:mm"),
  audienceLetter: z.any(),
});

export type AudiencePayload = z.infer<typeof AudienceValidation>;
